Hop.defineModule('toggle-password-visibility', (root) => {
    const component = root;
    const input = component.querySelector('input[type="password"]');
    const iconEye = component.querySelector('[data-eye]');
    const iconEyeMasked = component.querySelector('[data-eye-masked]');

    handleErrors();
    addListeners();

    function getInputType() {
        return input.getAttribute('type');
    }

    function inputValue() {
        return !!input.value;
    }

    function addListeners() {
        [iconEye, iconEyeMasked].forEach((icon) => {
            icon.addEventListener('click', (e) => {
                togglePassword(e.currentTarget);
            });
        });

        input.addEventListener('input', toggleEye);
    }

    function toggleEye() {
        if (inputValue() && getInputType() === 'password') {
            showEyeIcon();
        } else if (inputValue() && getInputType() === 'text') {
            showEyeMaskedIcon();
        } else {
            hideAllIcon();
        }
    }

    function togglePassword(e) {
        const getType = getInputType() === 'password' ? 'text' : 'password';
        input.setAttribute('type', getType);
        e.hasAttribute('data-eye') ? showEyeMaskedIcon() : showEyeIcon();
    }

    function showEyeMaskedIcon() {
        iconEye.setAttribute('hidden', 'hidden');
        iconEyeMasked.removeAttribute('hidden');
    }

    function showEyeIcon() {
        iconEyeMasked.setAttribute('hidden', 'hidden');
        iconEye.removeAttribute('hidden');
    }

    function hideAllIcon() {
        iconEyeMasked.setAttribute('hidden', 'hidden');
        iconEye.setAttribute('hidden', 'hidden');
    }

    function handleErrors() {
        if (!iconEye || !iconEyeMasked || !input) {
            throw new Error('There is no input password or icon in your component');
        }
    }

    return function destroy() {
        [iconEye, iconEyeMasked].forEach((icon) => {
            icon.removeEventListener('click', (e) => {
                togglePassword(e.currentTarget);
            });
        });

        input.removeEventListener('input', toggleEye);
    };
});
